import React, { useEffect, useState } from 'react';
import DataList from '../../components/DataList';
import { useNavigate } from 'react-router-dom';
import { getSingleAdminService } from '../../services/usersServices';
import { Button } from '@mui/material';

const ShowProfile = () => {
    const [adminData, setAdminData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const { userId, userRole } = localStorage.getItem("cncToken") ? JSON.parse(localStorage.getItem("cncToken")) : navigate("/auth/login");

    const adminRows = [
        {
            field: null,
            text: "نام کامل",
            element: (rowData) => <span>{rowData.name} {rowData.family}</span>
        },
        {
            field: null,
            text: "نقش",
            element: (rowData) => <span>{userRole.name}</span>
        },
        {
            field: "phone_number",
            text: "شماره تلفن"
        },
        {
            field: "email",
            text: "پست الکترونیک"
        },
        {
            field: null,
            text: "نام شرکت",
            element: (rowData) => <span>{rowData.company_info?.name}</span>,
        },
        {
            field: null,
            text: "شناسه ملی شرکت",
            element: (rowData) => <span>{rowData.company_info?.national_id}</span>,
        },
        {
            field: null,
            text: "شماره ثبت شرکت",
            element: (rowData) => <span>{rowData.company_info?.registration_number}</span>,
        },
        {
            field: null,
            text: "کد اقتصادی شرکت",
            element: (rowData) => <span>{rowData.company_info?.economic_code}</span>,
        },
        {
            field: null,
            text: "استان",
            element: (rowData) => <span>{rowData.company_info?.province}</span>,
        },
        {
            field: null,
            text: "شهر",
            element: (rowData) => <span>{rowData.company_info?.city}</span>,
        },
        {
            field: null,
            text: "ادرس شرکت",
            element: (rowData) => <span>{rowData.company_info?.registration_address}</span>,
        },
        {
            field: null,
            text: "تلفن ثابت شرکت",
            element: (rowData) => <span>{rowData.company_info?.registration_phone_number}</span>,
        },
        {
            field: null,
            text: "شماره شبا",
            element: (rowData) => <span>{rowData.company_info?.shaba}</span>,
        },
        {
            field: null,
            text: "کد پستی شرکت",
            element: (rowData) => <span>{rowData.company_info?.postal_code}</span>,
        },
    ];
    const handleGetDataOfAdmin = async (adminId) => {
        setIsLoading(true);
        try {
            const response = await getSingleAdminService(adminId);
            if (response.status === 200) {
                setAdminData(response.data);
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        handleGetDataOfAdmin(userId);
    }, []);

    return (
        <div className="max-w-screen-md mx-auto">
            <h2 className="text-center mb-10 text-xl">اطلاعات شما</h2>
            <DataList
                listData={adminData}
                listRowsTitles={adminRows}
                isLoading={isLoading}
            />
            {/* <div className="text-center">
                <Button type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => navigate("/change-profile")}
                >
                    ویرایش اطلاعات
                </Button>
            </div> */}
        </div>
    );
}

export default ShowProfile;
